module.exports = __webpack_public_path__ + "b3f5ed887c8425e0a74f11d69a5924b5.pdf";